import styled from '@emotion/styled';

const spacing = {
  small: '12px',
  medium: '16px',
  xLarge: '24px',
};

const StyledDialogActions = styled('div')`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  padding: ${spacing.small} ${spacing.xLarge} ${spacing.small};
  & > *:not(:last-child) {
    margin-right: ${spacing.medium};
  }
`;

export default StyledDialogActions;
